import { jsx as d } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { chakra as n } from "@chakra-ui/react";
import { useInputStyle as s } from "../Input.context.es.js";
const a = m((r, t) => {
  const o = s();
  return /* @__PURE__ */ d(n.div, { ref: t, __css: { ...o.addon, ...o.rightAddon }, ...r });
});
export {
  a as InputRightAddon
};
//# sourceMappingURL=InputRightAddon.es.js.map
